import type {BasePanel} from "@Components/panel/panel.types";

export const SCROLL_TOP_OFFSET = 400;

export const STYLES_INPUT_PANEL_ID = 'stylesInputPanel';

export type ApplyStylesHandler = (selectedColor: string, selectedFont: string, selectedImageURL?: string) => void;
export type ApplyBrandKitHandler = (selectedColorHex?: string, selectedFontFamily?: string, selectedImageURL?: string) => void;
export type ColorChangeHandler = (newColor: string) => void;
export type FontChangeHandler = (newFontFamily: string) => void;
export type ImageChangeHandler = (newImageURL: string) => void;
export type GAEventsMap = Partial<Record<StylesInputPanelGAEventType, string>>

export enum StylesInputPanelSection {
    DEFAULT = 'default',
    COLORS = 'colors',
    FONTs = 'fonts'
}

export interface StylesInput {
    selectedColorHex: string;
    selectedFontFamily?: string;
    selectedImageURL?: string
}

export interface StylesInputContentParams {
    selectedColorHex: string;
    onSelectColorHex: ColorChangeHandler;
    selectedFontFamily: string;
    selectedImageURL?: string;
    onSelectFontFamily?: FontChangeHandler;
    onImageUploadStart?: () => void;
    onSelectImage?: ImageChangeHandler;
    allowImageSelection?: boolean;
    className?: string;
    gaEventsMap?: GAEventsMap
}

export interface StylesInputPanelProps extends StylesInputContentParams {
    onClose?: VoidFunction;
}

export enum StylesInputPanelGAEventType {
    IMAGE = 'image',
    COLOR = 'color',
    FONT = 'font',
    BRAND_KIT = 'brand_kit'
}